import React from "react";

export default function NoCpsInRangeNotice(props) {
  var kind = props.hasMap ? "within 40 miles" : "within this limited distribution network";

  return !props.disableNoCpsInRangeNotice && props.noCpsInRange ? (
    <div
      className="stat-cards__notice stat-cards__notice--blue stat-cards__notice--mb"
      style={{ lineHeight: 1.5 }}
    >
      {`Our records indicate the selected entity does not have any active contract pharmacy arrangements ${kind}.
          The entity must establish a contract pharmacy arrangement with a pharmacy ${kind} to access 340B pricing.
          Please reach out to support@340besp.com for further assistance on this.`}
    </div>
  ) : null;
}
